import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

type VisibilityState = 'visible' | 'hidden';

@Component({
  selector: 'app-fade-transition',
  template: `
    <div [@visibilityState]="visibilityState"
         [hidden]="isHidden"
         (@visibilityState.start)="visibilityStateTransitionStarted()"
         (@visibilityState.done)="visibilityStateTransitionFinished()">
      <ng-content></ng-content>
    </div>
  `,
  animations: [
    trigger('visibilityState', [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('hidden => visible', animate('.4s ease-in')),
      transition('visible => hidden', animate('.4s ease-out')),
    ])
  ]
})
export class FadeTransitionComponent {
  public visibilityState: VisibilityState = 'hidden';
  public isHidden: boolean = true;

  @Input()
  public set isVisible(bool: boolean) {
    this.visibilityState = bool ? 'visible' : 'hidden';
  }

  public visibilityStateTransitionStarted(): void {
    this.isHidden = false;
  }

  public visibilityStateTransitionFinished(): void {
    this.isHidden = this.visibilityState === 'hidden';
  }
}
